const agnicoEagle = {
  itemDescription: "Description de l'item",
  itemNumber: "Numéro de l'item",
  purchaseOrderNumber: 'Numéro de commande',
};

export default agnicoEagle;
